// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-F":"F_outdoor-recreation-F__KR1OW"};